import mvtCheckbox from '@/common/components/mvtcheckbox/mvt-checkbox.vue';
import mvtInputDecimalNumber from '@/common/components/mvtinputdecimalnumber/mvt-inputdecimalnumber.vue';
import mvtInputNumber from '@/common/components/mvtinputnumber/mvt-inputnumber.vue';
import mvtSelect from '@/common/components/mvtselect/mvt-select.vue';
import mvtTextbox from '@/common/components/mvttextbox/mvt-textbox.vue';
import format from '@/common/utilities/format';
import motime from '@/common/utilities/motime';
import getStateByZipCode from '@/common/utilities/statesByZipcode';
import { mapActions, mapGetters } from 'vuex';
import { getPathBySearchObj } from '../../../../widget/spec/searchHelper';
export const RATETYPES = {
  PURCHASE: 'purchase',
  REFINANCE: 'refinance'
}

export default {
  name: 'compareRates',
  inject: ['$eventBus'],
  components: {
    mvtSelect,
    mvtTextbox,
    mvtCheckbox,
    mvtInputNumber,
    mvtInputDecimalNumber
  },
  props: {
    defaultRateType: {
        type: [String],
        default: RATETYPES.PURCHASE
    },
    pid: {
      type: String,
      default: ''
    },
    propertyData: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      disclaimerHtml: '',
      hasDataInitialized: false, // prevents pre-data rates fetch trigger
      geo: {},
      validZipLength: 5,
      showAllRates: false,
      showExtraFields: false,
      rates: {
        isRefinance: this.defaultRateType === RATETYPES.REFINANCE,
        zipcode: '',
        state: '',
        propertyValue: 0,
        loanAmount: 0,
        downpaymentRate: 25,
        loanPeriod: null,
        creditScore: null,
        propertyType: null,
        propertyUse: null,
        militaryVeteran: null,
        mortgagePoints: null,
        fhaLoan: false
      },
      loanPeriodList: [],
      creditScoreList: [],
      propertyTypeList: [
        { text: 'House', value: 'SINGLE_FAMILY_HOUSE' },
        { text: 'Condo/Townhouse', value: 'CONDO' },
        { text: 'Multi-family', value: 'MULTI_FAMILY' },
        { text: 'Lot/Land', value: 'LAND' },
        { text: 'Mobile', value: 'MOBILE' },
        { text: 'Other', value: 'OTHER' }
      ],
      propertyUseList: [
        { text: 'Primary', value: 'PrimaryResidence' },
        { text: 'Vacation', value: 'SecondaryOrVacation' },
        { text: 'Investment', value: 'InvestmentOrRental' }
      ],
      militaryVeteranList: [
        { text: 'Non-Military', value: 'NoMilitaryService' },
        { text: 'Regular Military', value: 'RegularMilitary' },
        { text: 'Reserves', value: 'Reserves' },
        { text: 'National Guard', value: 'NationalGuard' },
        { text: 'Military Spouse', value: 'MilitarySpouse' },
        { text: 'Reserve Spouse', value: 'ReserveSpouse' }
      ],
      mortgagePointsList: [
        { text: 'All', value: 'all' },
        { text: 'None', value: 'none' },
        { text: '0+', value: '0+' },
        { text: '1+', value: '1+' }
      ],
      fhaLoanData: [{ value: true, defaultValue: false }],
      // fetched mortgages related variables
      isFetchingMortgages: true,
      cordlessLoaded: false,
      providerName: '',
      interestPeriodTextMap: {},
      mortgageRates: [],
      mortgageSort: [
        { text: 'APR', value: 'apr', tip: this.molang('commons.aprTip'), descending: false, active: true },
        { text: 'Rate', value: 'rate', tip: this.molang('commons.rateTip'), descending: false, active: false },
        { text: 'Monthly Payment', value: 'estpayment', tip: this.molang('commons.repaymentTip'), descending: false, active: false}
      ],
      informaDisclaimer: '',
      informaDisclosureContent : ''
    };
  },
  mounted() {
    this.geo = this.glb.geo || {};
    this.rates.zipcode = this.toZipString(this.geo.zipcode) || '94403';
    this.rates.state = this.geo.state || 'CA';
    this.rates.city = this.geo.city || '';
    if (this.getMortgageOptionsData) {
      // value initialization for variables
      this.loanPeriodList = (this.getMortgageOptionsData.interestRateList || []).map(option => {
        return {
          ...option,
          value: option.period
        };
      });
      this.creditScoreList = this.getMortgageOptionsData.creditList || [];
      this.interestPeriodTextMap = this.getMortgageOptionsData.interestPeriodTextMap || {};
    }
    // set form drop-down selected options
    this.rates.loanPeriod = this.loanPeriodList[0].value;
    this.rates.creditScore = this.creditScoreList[0].value;
    this.rates.propertyType = this.propertyData ? this.propertyData.propertyType : this.$route.query.propertyType || this.propertyTypeList[0].value;
    this.rates.propertyUse = this.propertyUseList[0].value;
    this.rates.militaryVeteran = this.militaryVeteranList[0].value;
    this.rates.mortgagePoints = this.mortgagePointsList[0].value;
    if(window && window.location && window.location.search){
      this.rates.zipcode =  this.$route.query.zipcode || this.rates.zipcode;
    }
    if(this.propertyData || this.$route.query.price){
      this.rates.propertyValue = this.propertyData && this.propertyData.price || this.$route.query.price;
      this.updataDownpayment();
      this.enableMortgageRatesFetch();
    } else{
      this.initAveragePropertyValuation();
    }
    /* fetch('https://widgets.icanbuy.com/DisclaimerAPI.aspx')
        .then(response => response.text())
        .then(str => new window.DOMParser().parseFromString(str, "text/xml"))
        .then(xmlDoc => {
            const disclaimer = xmlDoc.querySelector("disclaimertext").textContent
            this.disclaimerHtml = disclaimer.replace(/<script[^>]*>.*?<\/script>/g, '');
        }); */
  },
  computed: {
    ...mapGetters('glb', ['glb', 'getMortgageOptionsData', 'getSplit']),
    propertyValue() {
      return this.rates.propertyValue;
    },
    loanAmount(){
      return this.rates.loanAmount;
    },
    filteredMortgageRates() {
      if (this.showAllRates) {
        return this.mortgageRates;
      } else {
        return this.mortgageRates.slice(0,5);
      }
    },
    isBankRate(){
      return this.mortgageRates && this.mortgageRates[0] && this.mortgageRates[0].feesRaw;
    }
  },
  watch: {
    propertyValue: {
      handler: function(newVal){
        if(newVal){
          this.updataDownpayment();
        }
      }
    },
    loanAmount: {
      handler: function(newVal){
        if(newVal){
          if(newVal > this.rates.propertyValue){
            this.rates.propertyValue = this.rates.loanAmount;
          }
          this.rates.downpaymentRate = Math.trunc((this.rates.propertyValue - this.rates.loanAmount) * 100 / this.rates.propertyValue);
        }
      }
    },
    rates: { // listen to this.rates object changes
      handler: function(newValue) {
        this.debouncedRatesFieldsWatcher(newValue);
      },
      deep: true
    }
  },
  methods: {
    ...mapActions('glb', ['getMortgageInfo', 'fetchAllZipListings']),
    nextBtn() {
      if (this.providerName) {
          this.$eventBus.$emit('ga', { el: this.providerName.replace(/(\s)+/g, '_') + '_Click', props: { link_name: 'Next' } });
      }
    },
    initAveragePropertyValuation() {
      if (this.rates.zipcode.length === this.validZipLength) {
        this.rates.state = getStateByZipCode(this.rates.zipcode);
        const urlPath = this.getCityZipUrl(this.rates.zipcode, this.rates.state);
        this.getHouseListings(urlPath);
      } else {
        this.enableMortgageRatesFetch();
      }
    },
    getCityZipUrl(zipcode, stateCode) {
      return getPathBySearchObj({ zipcode: zipcode, stateCode: stateCode });
    },
    async getHouseListings(urlPath) {
      try {
        const res = await this.fetchAllZipListings({ zipcodePath: urlPath });
        if (res && res.data && res.data.length) {
          const allPriceSum = res.data.reduce((prevSum, listing) => {
            return prevSum + listing.listPrice;
          }, 0);
          // assign average of all price
          this.rates.propertyValue = Math.round(allPriceSum / res.data.length);
          this.updataDownpayment();
          // value watcher on "this.rates" should trigger next
        }
      } catch (error) {
        console.log('Failed to fetch listings -', error);
      } finally {
        this.enableMortgageRatesFetch();
      }
    },
    debouncedRatesFieldsWatcher: function(newValue) {
      if (this.hasDataInitialized && this.rates.zipcode.length === this.validZipLength) {
        this.refreshAvailableMortgages();
      }
    },
     refreshAvailableMortgages() {
      if (!this.rates.zipcode) {
        return;
      }
      this.invokeInforma();
    },
    async invokeInforma(){
      try {
        const self = this;
        const queryParams = {
          pid: this.pid || `movoto_${this.glb.pageType}`,
          propertyId: this.propertyData && this.propertyData.propertyId,
          zip: this.rates.zipcode,
          state: this.rates.state,
          price: this.rates.propertyValue,
          propertyType: this.rates.propertyType,
          period: this.rates.loanPeriod,
          loanAmount: this.rates.loanAmount,
          loanType: this.rates.isRefinance ? 'refinance' : 'purchase',
          transaction:  this.rates.isRefinance ? 54 : 52,
          propertyUse: this.rates.propertyUse,
          veteranStatus: this.rates.militaryVeteran,
          fico: this.rates.creditScore,
          point: this.rates.mortgagePoints,
          fhaLoan: this.rates.fhaLoan,
          utmcta: this.glb.pageType === 'vdpp' ? 'apicalculate' : (this.rates.isRefinance ? 'vrefinancerates' : 'vpurchaserates')
        };
        this.isFetchingMortgages = true;
        this.providerName = 'Informa Rate'
        const response = await this.getMortgageInfo(queryParams);
        let mortgages = []
        if(response) {
          this.informaDisclaimer = response.disclaimerHtml;
          this.informaDisclosureContent = response.advertiserDisclosure;
          mortgages = response.rates || []
        }
        if(mortgages && mortgages.length){
          const processedMortgages = (mortgages || []).map(mortgage => {
            // allocate UI friendly property text. May use filter instead
            mortgage.productText = self.interestPeriodTextMap[mortgage.productName] || mortgage.productName;
            mortgage.apr = format.fixedThreeDigits(mortgage.apr);
            mortgage.rate = format.fixedThreeDigits(mortgage.rate);
            mortgage.date = motime.formatDate(new Date(), { month: 'short', day: 'numeric', year: 'numeric' });
            mortgage.cpc = `${mortgage.cpc}&pageType=${this.glb.pageType}&utm_source=movoto`;
            return mortgage;
          });
          this.mortgageRates = processedMortgages;
          let item = this.mortgageSort.find(e=> e.active);
          this.sortMortgageBy(item.value, item.descending);
          if(this.isBankRate){
            this.providerName = 'Bankrate Rate'
          }
          if(this.providerName){
            this.$eventBus.$emit('ga', {el: this.providerName.replace(/(\s)+/g, '_') + '_Returned', props:{link_name: mortgages.length }});
          }
        }
        else{
          this.$eventBus.$emit('ga', { en: 'Rate_API_Call', ec: 'Rate_API_Results', el: 'No Rates Returned' , props:{link_name: 0 }}) //cordless was called first and then informa, both did not return
        }
      } catch(error) {
        console.log('Failed to fetch mortgages -', error);
      } finally {
        this.isFetchingMortgages = false;
      }
    },
    updataDownpayment() {
      if (this.rates.downpaymentRate > 100) {
          this.rates.downpaymentRate = 100;
      } else if (this.rates.downpaymentRate < 0) {
          this.rates.downpaymentRate = 0;
      }
      // calculate remaining amount and assign as loan amount
      const remainingAmount = this.rates.propertyValue - Math.round(this.rates.propertyValue * this.rates.downpaymentRate / 100);
      this.rates.loanAmount = remainingAmount;
    },
    sortMortgageBy(keyName, isDesc) {
      // update header flag status
      for (let i = 0; i < this.mortgageSort.length; i++) {
        this.mortgageSort[i].active = this.mortgageSort[i].value === keyName;
        if(this.mortgageSort[i].active){
          this.mortgageSort[i].descending = isDesc;
        }
      }
      // sort the array
      this.mortgageRates = this.mortgageRates.slice().sort((a, b) => {
        const sortValueFirst = a[keyName] && a[keyName] * 1 || 0;
        const sortValueSecond = b[keyName] && b[keyName] * 1 || 0;
        return isDesc ? (sortValueSecond - sortValueFirst) : (sortValueFirst - sortValueSecond);
      });
    },
    enableMortgageRatesFetch() {
      this.hasDataInitialized = true;
    },
    setRateFlag(flagValue) {
      this.rates.isRefinance = flagValue;
    },
    toZipString(zip) {
      return zip && zip.toString();
    }
  }
};